import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { TvContext } from '../../context/TvContext';
import { SocketContext, socke } from '../../context/SocketContext';
import CreateSession from './CreateSession';
import JoinSession from './JoinSession';
import Room from './Room';

import './session.css';

const Session = (props) => {

    const { tvState, setTvState } = useContext(TvContext);
    const { socket, setSocket } = useContext(SocketContext);
    const [sessionState, setSessionState] = useState(props.player ? 'CREATE' : 'JOIN');
    const [joinStatus, setJoinStatus] = useState('NONE');
    const [createStatus, setCreateStatus] = useState('NONE');
    const history = useHistory();

    const createRoom = (roomId) => {
        console.log(props)
        var info = {}

        if (props.info.type == "m") {
            info = {
                room: roomId,
                movie: props.info.movie,
                mid: props.info.mid,
                type: "m"
            }
        }
        else {
            info = {
                room: roomId,
                show: props.info.show,
                season: props.info.season,
                episode: props.info.episode,
                tid: props.info.tid,
                type: "s"
            }
        }

        socket.emit('createRoomShow', info);
        socket.on('createRoomShow', data => {
            console.log(data);
            if (data !== null) {
                setCreateStatus('SUCCESS');
                joinRoom(roomId);
            }
            else {
                setCreateStatus('ERROR');
            }
        })

    }

    const joinRoom = (roomId) => {
        socket.emit('joinRoom', { 'token': localStorage.getItem('token').slice(7), 'room': roomId })
        socket.on('roomInfo', data => {
            if (data !== null) {
                setJoinStatus('SUCCESS');
                setTvState({
                    ...tvState,
                    groupChat: {
                        ...tvState.groupChat,
                        sessionId: roomId,
                        sessionConnected: true
                    }
                })
                setSessionState('INROOM');
                console.log(data)
                if (data.type == 's') {
                    history.push(`/player?type=${data.type}&show=${data.show}&season=${data.season}&episode=${data.episode}&tid=${data.tid}`);
                }
                else {
                    history.push(`/player?type=${data.type}&movie=${data.movie}&mid=${data.mid}`);
                }
            }
            else
                setJoinStatus('ERROR');
        }
        );
    }

    const disconnectSession = () => {
        // socket.disconnect();
        socket.emit('leaveRoom');
        setTvState({
            ...tvState,
            groupChat: {
                ...tvState.groupChat,
                sessionId: '',
                sessionConnected: false
            }
        });
        setSessionState('CREATE');
    }

    useEffect(() => {
        if (tvState.groupChat.sessionId !== '') {
            setSessionState('INROOM');
        }
        return () => {

        }
    }, []);



    return <>{
        tvState.groupChat.active ?
            <div style={{ position: props.player ? 'fixed' : 'absolute', width: '250px', height: props.player ? '100%' : '220px', background: '#111', color: 'white', right: '0px', padding: '10px' }}>
                {!tvState.groupChat.sessionConnected ?
                    <div className="session_section">
                        {props.player ? <button className="join__button" onClick={() => setSessionState('CREATE')}>Create Room</button> : null}
                        <button className="join__button" onClick={() => setSessionState("JOIN")}>Join Room</button>
                    </div> : null
                }
                {sessionState === 'CREATE' ? <CreateSession create={createRoom} status={createStatus} /> : null}
                {sessionState === 'JOIN' ? <JoinSession join={joinRoom} status={joinStatus} /> : null}
                {sessionState === 'INROOM' ? <Room leave={disconnectSession} room={tvState.groupChat.sessionId} height={props.height} video={props.video} /> : null}
            </div> : null}</>
}

export default Session;